// 安心安全メールの過去一覧ページ

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

/*-------------------
    classのimport
---------------------*/
import * as commons from '../commons';
import Footer from '../components/Footer';
/*-------------------
    cssのimport
---------------------*/
import '../css/safety.css';

// クラス名
class FAQ extends Component {
  constructor(props) {
    super(props);

    // URLから安心安全メールのコードを取得。
    const url = props.location.pathname;
    const num = url.lastIndexOf('/');
    const cryptUrl = url.slice(num + 1);
    this.state = { cryptUrl };
  }

  componentDidMount = async () => {
    const { cryptUrl } = this.state;

    // サイト情報を取得する。
    const resData = await commons.siteSetting(cryptUrl);
    const { setting, footer } = resData;

    if (setting === true) return;
    if (setting.length === 0) {
      commons.moveErrorPage(this.props, '10');
      return;
    }

    const { site_info: siteInfo, lcl_gov: lclGov } = setting[0];
    const { lg_cd: lgCd = '' } = lclGov;
    const { name: siteName = '', company = '' } = siteInfo;

    // アカウント情報を取得する。
    const accountSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_ACCOUNT',
      kind: '2',
    });
    const { account_info: accountInfo } = accountSetting[0];
    const { from_address: fromAddress } = accountInfo;

    // FAQ情報を取得する。
    const faqSetting = await commons.commonSetting({
      lgCd,
      enable: true,
      colName: 'M_FAQ',
      kind: '2',
    });

    document.title = `${siteName}`;

    const faqContent = this.createFaqContent(faqSetting, siteName, fromAddress, company);

    this.setState({ footer, ...faqContent, siteName });
  };

  // 質問集を作る。
  createFaqContent = (faqSetting, siteName, fromAddress, company) => {
    const { cryptUrl } = this.state;
    const { faq_info: faqInfo = [] } = faqSetting[0] || '';

    const questionList = [];
    const answerList = [];
    for (let i = 0; i < faqInfo.length; i += 1) {
      const { head = '', faq_list: faqList = [] } = faqInfo[i];
      const tmpQuestionList = [];
      for (let j = 0; j < faqList.length; j += 1) {
        const { question, answer } = faqList[j];

        const tmpQuestion = question
          .replace(/{cryptUrl}/g, cryptUrl)
          .replace(/{siteName}/g, siteName)
          .replace(/{fromAddress}/g, fromAddress)
          .replace(/{company}/g, company);

        // 質問リスト作成
        tmpQuestionList.push(
          <li key={`q_list_${i}${j}`}>
            <a href={`#list_${i}${j}`}>{tmpQuestion}</a>
          </li>
        );

        const tmpAnswer = answer
          .replace(/{cryptUrl}/g, cryptUrl)
          .replace(/{siteName}/g, siteName)
          .replace(/{fromAddress}/g, fromAddress)
          .replace(/{company}/g, company);

        const htmlString = `A.${tmpAnswer}`;
        const safeHtml = DOMPurify.sanitize(htmlString);

        // 下のQ&A
        answerList.push(
          <section key={`a_list_${i}${j}`} id={`list_${i}${j}`} className="q_a">
            <h3 className="bold mb10">Q.{tmpQuestion}</h3>
            {/* <div>{commons.shapedContents(`A.${answer}`)}</div> */}
            <p dangerouslySetInnerHTML={{ __html: safeHtml }} />
          </section>
        );
      }
      // 上部のリスト側
      questionList.push(
        <div key={`q_list_${i}`} className="mb20">
          <h2 className="bold">{head}</h2>
          <ul>{tmpQuestionList}</ul>
        </div>
      );
    }

    return { questionList, answerList };
  };

  onClickBtnMove = (path) => {
    const { cryptUrl } = this.state;
    const { history } = this.props;
    history.push({ pathname: `${path}/${cryptUrl}` });
  };

  render() {
    const { siteName, footer = '', questionList = [], answerList = [] } = this.state;

    if (footer === '') return true;

    return (
      <div id="safety-container">
        <div className="safety-back">
          <div className="safety-title">{siteName}</div>
          <div className="safety-content">
            <div className="safety-top">
              よくあるご質問をまとめています。 お問合せの前に、ご一読ください。
            </div>
            <section className="safety-exposition mt20">
              {questionList}
              {answerList}
            </section>
            <div className="safety-fot">
              <button
                type="button"
                className="btnAtag mt20"
                onClick={() => {
                  this.onClickBtnMove('../home');
                }}
              >
                トップページに戻る
              </button>
              {footer}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

FAQ.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(FAQ);
